import { Link } from "gatsby"
import PropTypes from "prop-types"
import { Container } from "reactstrap";
import React, { Component } from "react"
import { FaSearch, FaArrowRight } from "react-icons/fa";
import styled from "styled-components";
import gens3d from "../images/3DGENS_LOGO.png"
import "../styles/header.css"
import LinkButtonSecondary from "./buttons/LinkButtonSecondary";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar } from "react-bootstrap";
import { Nav } from "react-bootstrap";
import { NavDropdown } from "react-bootstrap";



const NavBarStyled = styled(Navbar)`
&&&{
    .nav-link{
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
      color: #17a99e;
      margin-left: 30px;
      :hover{
        color: #007068;
      }
      :focus{
        color: #17a99e;
      }
    }
    .dropdown-item{
      color: #17a99e;
    }
  }
  `
const SmallBar = styled.div`
  background-color: #ccc;
  height: 1rem;
`
const LogoBox = styled.div`
  margin-top: 10px;
  margin-left: 30px;
`
const LogoHeader = styled.img`
  width: 240px;
  height: auto;
  margin-bottom: 0;
`
const NavBarred = styled.div`
  background-color: #fff;
  text-align: center;

  a{
    font-size: 16px;
    color: black;
    padding: 10px 15px;
    text-decoration: none;
  }
  a:hover{
    color: #1ae99e
  }
`
const DropdownBox = styled.div`
  display: inline-block;
  font-size: 16px;
  .dropbutton{
    color: black;
    background-color: inherit;
    :hover{
      color: #1ae99e;
    }
  }
  .dropcontent{
    display: none;
    position: absolute;
    z-index: 2;
    a{
      color: black;
      background-color: #fff;
      display: block;
      text-align left;
      text-decoration: none;
      :hover{
        color: 1ae99e;
        background-color: #ddd;
      }
    }
  }
  :hover{
    .dropcontent{
      display: block;
    }
  }
`

export default class Navigation extends React.Component {

  render() {
    return (
      <header>
        <SmallBar/>
        <LogoBox>
          <Container>
            <a href="/" style={{textDecoration:"none"}}>
              <LogoHeader src={gens3d} alt="logo" />
            </a>
          </Container>
        </LogoBox>
        <NavBarred>
          {/* <a href="/">What Is AM</a> */}
          <a href="/about">Who We Are</a>
          {/* <DropdownBox>
            <div className="dropbutton">
              Who We Are
            </div>
              <div className="dropcontent">
                <a href="/about">About US</a>
                <a href="/">AM Equipment</a>
              </div>
          </DropdownBox> */}
          <DropdownBox>
            <div className="dropbutton">
              How we can Help
            </div>
              <div className="dropcontent">
                <a href="/training">Improve your Compentency</a>
                <a href="/research">Expand Your Research</a>
              </div>
          </DropdownBox>
          <DropdownBox>
            <div className="dropbutton">
              Technology Areas
            </div>
              <div className="dropcontent">
                <a href="/engineering">Engineering Works</a>
                <a href="/medical">Medical Aplication</a>
                <a href="/digital-dentistry">Digital Dentistry</a>
                <a href="/printer">AM Machine</a>
                <a href="/scanner">3D Model Scanning</a>
              </div>
          </DropdownBox>
          <a href="/stories">News</a>
          <a href="/contact">Contact</a>


        </NavBarred>



        <Container>
        {/* <NavBarStyled collapseOnSelect expand="lg">
        <NavBarStyled.Brand href="/">
          <LogoHeader src={gens3d} alt="logo"/>
        </NavBarStyled.Brand>
        <NavBarStyled.Toggle aria-controls="responsive-navbar-nav" />
        <NavBarStyled.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto">
            <NavDropdown title="What is AM" id="collasible-nav-dropdown">
              <NavDropdown.Item href="/about/#about">AM Benefits</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Who We Are" id="collasible-nav-dropdown">
              <NavDropdown.Item href="/about/#about">About Us</NavDropdown.Item>
              <NavDropdown.Item href="/about/#iso">AM Equipment</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Product & Services" id="collasible-nav-dropdown">
              <NavDropdown.Item href="/medical">Medical</NavDropdown.Item>
              <NavDropdown.Item href="/digital-dentistry">Digital Dentistry</NavDropdown.Item>
              <NavDropdown.Item href="/engineering">Engineering</NavDropdown.Item>
              <NavDropdown.Item href="/training">Training</NavDropdown.Item>
              <NavDropdown.Item href="/research">Research</NavDropdown.Item>
              <NavDropdown.Item href="/printer">3D Printer</NavDropdown.Item>
              <NavDropdown.Item href="/scanner">3D Scanner</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="/career">Career</Nav.Link>
            <Nav.Link href="/about/#contact">Contact Us</Nav.Link>
          </Nav>
        </NavBarStyled.Collapse>
      </NavBarStyled> */}

      </Container>

      </header>
    );
  }
}

